import { Button } from '@/cn/ui/button'
import { useNavigate } from 'react-router-dom'

const MerchantHome = () => {
  const navigate = useNavigate()
  const enterAmountfn = () => {
    navigate(`merchant/enteramount`)
  }
  return (
    <div className="flex flex-col gap-4 mt-4">
      <div className="flex relative flex-col mt-[70px] items-center">
        <div className="text-[30px] text-center leading-[40px] font-semibold ">Take a payment</div>
        <Button className="text-white mt-5" onClick={enterAmountfn}>
          Create new order
        </Button>
      </div>

      <div className="bg-[#FEF3ED] absolute bottom-0 left-[-200px] h-[35vh] rotate-[-11deg] w-[1200px]"></div>
    </div>
  )
}

export default MerchantHome
